var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.initShow)?_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('transition',[_c('keep-alive',[_c(Component,{tag:"component"})],1)],1)]}}],null,false,853975882)}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }